import { render, staticRenderFns } from "./personlist.vue?vue&type=template&id=4accd0e4&scoped=true"
import script from "./personlist.vue?vue&type=script&lang=js"
export * from "./personlist.vue?vue&type=script&lang=js"
import style0 from "./personlist.vue?vue&type=style&index=0&id=4accd0e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4accd0e4",
  null
  
)

export default component.exports